import { Suspense, lazy, useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import MetricCard from '../components/MetricCard.jsx';
import ContactCTA from '../components/ContactCTA.jsx';
import AnimatedIcon from '../components/AnimatedIcon.jsx';
import AnimatedWrapper from '../components/AnimatedWrapper.jsx';

const OrbLoader = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 3200);
    return () => clearTimeout(timer);
  }, []);

  return ready ? (
    <div className="hero-visual-placeholder">Almost there…</div>
  ) : (
  <div className="hero-visual-placeholder" role="status" aria-live="polite">
    <div className="loader-wheel" aria-hidden="true" />
    <p className="loader-text">Loading visualization…</p>
  </div>
  );
};
const RotatingNetworkOrb = lazy(() => import('../components/RotatingNetworkOrb.jsx'));

const metrics = [
  {
    value: '76% uplift',
    label: 'Engagement',
    icon: 'analytics',
    description: 'A study by Retail Dive, 76% of consumers are more likely to visit a store with smart technology offering personalized experiences.',
  },
  {
    value: '30% retention',
    label: 'Repeat visits',
    icon: 'loyalty',
    description: 'Companies leveraging connected, smart devices see a 30% increase in customer retention rates.',
  },
  {
    value: '40% leaner',
    label: 'Operational spend',
    icon: 'energy',
    description: 'Smart devices yield significant savings in energy costs, while unlocking new creative bandwidth, by up to 40%.',
  },
];

const processSteps = [
  {
    title: 'Prototyping',
    copy: 'Rapid concepting with local artists and makers to visualize your connected experience.',
    icon: 'prototype',
  },
  {
    title: 'Deployment',
    copy: 'Installation crews integrate devices, signage, and analytics without disrupting daily flow.',
    icon: 'deploy',
  },
  {
    title: 'Optimization',
    copy: 'Continuous data-driven tuning and human-centered adjustments that keep the vibe dialed in.',
    icon: 'optimize',
  },
];

const Home = () => {
  const [showOrb, setShowOrb] = useState(false);

useEffect(() => {
  const timer = setTimeout(() => setShowOrb(true), 1200);
  return () => clearTimeout(timer);
}, []);
  return (
    <div className="page home-page">
      <section className="hero">
       
          <p className="eyebrow">San Diego-crafted, coast-to-coast impact</p>
      
        
        
          <h1 className='hero h1'>
            We build smart ecosystems that elevate your business and keeps your customers <span> coming back</span>
          </h1>
      
        
        <div className="hero-layout">
          <div className="hero-copy">
            
              <p className="hero-description">
                TapptiQ designs responsive devices that combine artistic vision, technological innovation, data-driven insights, and people-forward thinking into extraordinary experiences. Enhance your business with TAPPTiQ so your teams gain clarity, your guests feel the vibe, and your business realizes its full potential with integrity.
              </p>
          
          </div>

        
            <div className="hero-visual">
              <Suspense fallback={<OrbLoader />}>
                  {showOrb ? <RotatingNetworkOrb /> : <OrbLoader />}
              </Suspense>
            </div>
          </div>

        {/* <AnimatedWrapper direction="up" delay={0}> */}
          <div className="hero-actions">
            <Link to="/services" className="button-primary hero-cta">
              See Our Solutions
            </Link>
            <a href="#contact" className="button-secondary hero-cta">
              Start Your Project
            </a>
          </div>
        {/* </AnimatedWrapper> */}
        
      </section>
      <section className="metrics-section">
        <AnimatedWrapper direction="up" delay={0}>
          <div className="section-heading">
            <p className="eyebrow">Performance as art</p>
            <h2>IoT intelligence that hits the metrics and the feels</h2>
          <p>
         Single Grain’s 2025 immersive marketing study cites AnyRoad research showing that 71% of brands using immersive marketing saw positive ROI, with 38% reporting ROI growth over 20%
            {' '}
            <sup>
              <a
                href="https://www.singlegrain.com/digital-marketing/how-immersive-experiences-are-revolutionizing-marketing/"
                target="_blank"
                rel="noreferrer"
              >[source]
              </a>
            </sup></p>
            
          
          </div>
        </AnimatedWrapper>
        <div className="metrics-grid">
          {metrics.map((metric, i) => (
            <AnimatedWrapper key={metric.label} direction="up" delay={i * 120}>
              <MetricCard {...metric} />
            </AnimatedWrapper>
          ))}
        </div>
      </section>
      <section className="process-section">
        <AnimatedWrapper direction="up" delay={0}>
          <div className="section-heading">
            <p className="eyebrow">Imagine · Engineer · Optimize</p>
            <h2>Responsive environments tuned to your story</h2>
            <p>
              From scannable sculptures to adaptive lighting, we prototype swiftly, deploy ethically, and iterate with insights so
              your operations feel effortless.
            </p>
          </div>
        </AnimatedWrapper>
        <div className="process-grid">
          {processSteps.map((step, i) => (
            <AnimatedWrapper key={step.title} direction="up" delay={i * 120}>
              <div className="process-card">
                <span className="process-icon" aria-hidden="true">
                  <AnimatedIcon name={step.icon} />
                </span>
                <h3>{step.title}</h3>
                <p>{step.copy}</p>
              </div>
            </AnimatedWrapper>
          ))}
        </div>
      </section>
     
        <ContactCTA />
     
    </div>
  );
};

export default Home;
